<section class="container py-5">
  <div class="back-button mb-4">
    <span class="back-icon" (click)="goBack()"><i class="fa-solid fa-arrow-left"></i></span>
    <h4 class="back-button-heading mx-3">My Policy</h4>
  </div>
  <section>
    <div class="d-flex justify-content-end mb-3" *ngIf="hideFields">
      <i class="fa-solid fa-file-excel download-icon" title="Download Report"
                (click)="InsertDownloadReports()"></i>
    </div>
    <h4 class="heading3 mb-2">Search By</h4>
    <form [formGroup]="myPolicyFilters">
      <div class="row mb-3">
        <div class="col-md-6 mb-2" *ngIf="hideFields">
          <label class="field-label">Organization Type</label>
          <mat-form-field class="w-100">
            <input type="text"
                   matInput
                   formControlName="organizationType"
                   [matAutocomplete]="orgType">
            <mat-autocomplete [displayWith]="orgTypeDisplayFn" (optionSelected)="onOrgTypeSelected($event)" #orgType="matAutocomplete">
              <mat-option *ngFor="let option of filteredOrganizationTypes | async" [value]="option">
                {{option.orgGroupRelationshipTypeName}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="col-md-6 mb-2" *ngIf="hideFields">
          <label class="field-label">Organization</label>
          <mat-form-field class="w-100">
            <input type="text"
                   matInput
                   formControlName="organization"
                   [matAutocomplete]="org">
            <mat-autocomplete [displayWith]="orgDisplayFn" #org="matAutocomplete">
              <mat-option *ngFor="let option of filteredOrganizations | async" [value]="option">
                {{option.orgName}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="col-md-4 mb-2">
          <label class="field-label">Policy Number</label>
          <mat-form-field class="w-100 mat-form-field-sm">
            <input matInput type="text" formControlName="policyNumber">
          </mat-form-field>
        </div>
        <div class="col-md-4 mb-2">
          <label class="field-label">Created From Date</label>
          <mat-form-field class="w-100">
            <input matInput [matDatepicker]="fromDate" [max]="currentDate" formControlName="fromDate" placeholder="DD/MM/YYYY">
            <mat-datepicker-toggle matIconSuffix [for]="fromDate"></mat-datepicker-toggle>
            <mat-datepicker #fromDate></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-md-4 mb-2">
          <label class="field-label">Created To Date</label>
          <mat-form-field class="w-100">
            <input matInput [matDatepicker]="toDate" [max]="currentDate" formControlName="toDate" placeholder="DD/MM/YYYY">
            <mat-datepicker-toggle matIconSuffix [for]="toDate"></mat-datepicker-toggle>
            <mat-datepicker #toDate></mat-datepicker>
          </mat-form-field>
        </div>
        <div  class="col-md-6 mb-2">
          <label class="field-label">Travel Purpose</label>
          <mat-form-field  class="w-100">
            <mat-select formControlName="travelPurpose">
              <mat-option *ngFor="let travelPurpose of getTravelPurposeList" [value]="travelPurpose.masterDataID">{{travelPurpose?.mdTitle}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div  class="col-md-6 mb-2">
          <label class="field-label">Destination</label>
          <mat-form-field class="example-full-width w-100">
            <input type="text" matInput formControlName="destination" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="destinationDisplayFn">
              <mat-option *ngFor="let option of destinationFilteredOptions | async" [value]="option">
                {{option.ToCountryName}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div  class="col-md-6 mb-2" *ngIf="hideFields">
          <label class="field-label">User</label>
          <mat-form-field class="example-full-width w-100">
            <input type="text" matInput formControlName="user" [matAutocomplete]="autoUser">
            <mat-autocomplete #autoUser="matAutocomplete" [displayWith]="userDisplayFn">
              <mat-option *ngFor="let option of userFilteredOptions | async" [value]="option">
                {{option.fullName}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div  class="col-md-6 mb-2" *ngIf="hideFields">
          <label class="field-label">Branch</label>
          <mat-form-field class="example-full-width w-100">
            <input type="text" matInput formControlName="branch" [matAutocomplete]="autoBranch">
            <mat-autocomplete #autoBranch="matAutocomplete" [displayWith]="branchDisplayFn">
              <mat-option *ngFor="let option of branchFilteredOptions | async" [value]="option">
                {{option.orgGroupName}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="myPolicyFilters.hasError('dateRangeRequired')" class="text-danger small">
        <p>Both From Date and To Date are required when either is selected.</p>
      </div>
      <div class="text-center">
        <button class="button1 mb-2 me-2" (click)="Filter()">Search</button>
        <button class="button1 mb-2" (click)="ClearFilter()">Reset</button>
      </div>
    </form>
  </section>
  <hr>
  <section class="my-5" *ngIf="myPolicyList.length>0">
  
    <div class=" table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col">Policy Number</th>
            <!-- <th scope="col">Policy Created By</th> -->
            <th scope="col">Travel Dates</th>
            <th scope="col">Destination</th>
            <th scope="col">Travel Purpose</th>
            <th scope="col">Number of Days</th>
            <th scope="col">Number of Travellers</th>
            <th scope="col">Status</th>
            <th scope="col">Source</th>
            <th scope="col">Created By</th>
            <th scope="col">Created Date</th>
            <th scope="col">Branch</th>
            <th scope="col">Download</th>
            <th scope="col">Modify</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let policy of myPolicyList| paginate: { itemsPerPage: resultPerpage?.value?? 10, currentPage: currentPage,totalItems: totalCount };let i=index">
            <td scope="row">
              <a class="link" (click)="policyDetailes(policy.QuotationID,policy.QuotesID)">{{policy.PolicyNumber}}</a>
            </td>
            <td scope="row">{{policy.FromDateString}} - {{policy.ToDateString}}</td>
            <td scope="row">{{policy.DestinationCountryName}}</td>
            <td scope="row">{{policy.TravelPurposeName}}</td>
            <td scope="row">{{policy.NoofDays}}</td>
            <td scope="row">{{policy.NoofTravellers}}</td>
            <td scope="row">{{policy.QuotationStatusName}}</td>
            <td scope="row">{{policy.QuotationSourceName}}</td>
            <td scope="row">{{policy.createdBy}}</td>
            <td scope="row">{{policy.CRTSString}}</td>
            <td scope="row">{{policy.BranchName}}</td>
            <td scope="row" class="text-center">
              <i class="fa-solid fa-cloud-arrow-down download-icon" title="Download Policy"
                (click)="DownloadPolicy(policy.certificateID)"></i>
            </td>
             <td scope="row" class="text-center">
              <i class="fa-solid fa-edit"  [attr.title]="policy.edit ? 'Edit' : 'Not Allowed'"
              [class.download-icon]="policy.edit"
              [class.disabled-icon]="!policy.edit" (click)="policy.edit && redirectToProposalForm(policy)"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-end mt-3" *ngIf="totalCount>0">
      <pagination-controls class="my-pagination" previousLabel="" nextLabel=""
        (pageChange)="currentPage = $event;onPageChange($event)"></pagination-controls>
      <div class="bg-white px-2 d-flex align-items-center">
        <span>
          Results per page
        </span>
        <span class="px-2">
          <select id="resultPerpage" [formControl]="resultPerpage">
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="150">150</option>
            <option value="200">200</option>
          </select>
        </span>
      </div>
    </div>
  </section>
  <section *ngIf="!isLoadingForMyPolicyList && myPolicyList.length==0">
    <div class="text-center">No Data found.</div>
  </section>
</section>